/** Flip to true when shop content is ready — also update robots.txt and renumber menu. */
export const SHOP_ENABLED = false;

export const SHOP_CATEGORIES = [
  { id: 'all', label: 'ALL' },
  { id: 'presets', label: 'PRESETS' },
  { id: 'templates', label: 'TEMPLATES' },
  { id: 'tools', label: 'TOOLS' },
  { id: 'resources', label: 'RESOURCES' },
];

export const shopProducts = [
  {
    id: 'p1',
    name: 'Product Name',
    category: 'presets',
    categoryLabel: 'PRESETS',
    format: 'LUT PACK',
    price: '€ 00',
  },
  {
    id: 'p2',
    name: 'Product Name',
    category: 'templates',
    categoryLabel: 'TEMPLATES',
    format: 'FIGMA',
    price: '€ 00',
  },
  {
    id: 'p3',
    name: 'Product Name',
    category: 'tools',
    categoryLabel: 'TOOLS',
    format: 'PLUGIN',
    price: '€ 00',
  },
  {
    id: 'p4',
    name: 'Product Name',
    category: 'resources',
    categoryLabel: 'RESOURCES',
    format: 'PDF',
    price: '€ 00',
  },
  {
    id: 'p5',
    name: 'Product Name',
    category: 'presets',
    categoryLabel: 'PRESETS',
    format: 'LIGHTROOM',
    price: '€ 00',
  },
  {
    id: 'p6',
    name: 'Product Name',
    category: 'templates',
    categoryLabel: 'TEMPLATES',
    format: 'AE PROJECT',
    price: '€ 00',
  },
];

export const SHOP_STATS = {
  total: shopProducts.length,
  format: 'DIGITAL ONLY',
  delivery: 'INSTANT DOWNLOAD',
};
